const productSummary = (el) => {
  const $el = $(el);
  const productForm = $el.closest('form');
  const productInput = productForm.find("input[type='radio']");

  const nrOfProductsText = $el.find('#nrOfProducts');
  const singlePriceText = $el.find('#productSinglePrice');
  const saleText = $el.find('#productSalePrice');
  const origanLtotalText = $el.find('#productOriginalTotal');
  const discountText = $el.find('#productDiscount');

  const percentagePriceText = $el.find('#percentagePrice');
  const totalText = $el.find('#totalCost');

  let discountTable = '';
  let quantity = 1;
  let selectedItem = {
    singlePrice: "0kr",
    quantity: 0,
    discountPrice: 0,
  };

  $(productInput).on("change", function() {
    if ($(this).prop("checked")) {
      selectedItem = $(this);

      const selectedProduct = inputChanges(selectedItem, quantity);
      console.log('SELECTED PRODUCT: ', selectedProduct);

      const hasDiscount = findDiscountTable(productForm);
      console.log('DISCOUNT TABLE: ', hasDiscount);

      updateSummaryItem(totalText, selectedProduct.singlePrice);
    }
  });

  $("input.qty").on("change", function() {
    quantity = parseInt($(this).val());

    if(isNaN(quantity) || quantity < 1) {
      quantity = 1;
    }

    const selectedProduct = inputChanges(selectedItem, quantity);
    const bulkDiscount = calculateBulkDiscount(selectedProduct.singlePrice, selectedProduct.discountPrice, quantity);

    updateSummaryItem(nrOfProductsText, quantity, false, true);
    updateSummaryItem(discountText, bulkDiscount * quantity);
    updateSummaryItem(totalText, selectedProduct.discountPrice * quantity);

    if(bulkDiscount) {
      totalText.addClass('has-discount')
      updateSummaryItem(origanLtotalText, selectedProduct.singlePrice * quantity);

    }

  });

  const inputChanges = (selectedItem, quantity) => {
    const $selectedItem = $(selectedItem); // ensure it's jQuery

    const singledItemPrice = $selectedItem.next('label').find('.woocommerce-Price-amount');

    const priceText = singledItemPrice;
    const numericPrice = parseInt(priceText.replace(/[^0-9]/g, ""), 10);

    let priceBasedOnQuantity = parseFloat(singledItemPrice.text().replace(/[^0-9.,]/g, "").replace(",", "."));

    if(quantity > 1) {
      priceBasedOnQuantity = getDiscountFromTable(quantity, discountTable);
    }

    return {
        singlePrice: parseFloat(singledItemPrice.text().replace(/[^0-9.,]/g, "").replace(",", ".")),
        quantity: quantity,
        discountPrice: priceBasedOnQuantity
      };
  }

  const findDiscountTable = (productForm) => {
    const priceRangeContainer = productForm.next('div');

    let refreshIntervalId = setInterval(function() {
      discountTable = priceRangeContainer.find('.wdr_bulk_table_tr.bulk_table_row');
    }, 2000);

    return refreshIntervalId;
  }

  const getDiscountFromTable = (quantity, priceRangeTable) => {

    const discountArray = priceRangeTable.map(function () {
      const range = $(this).find('.wdr_bulk_range').text().trim();
      const discount = parseFloat($(this).find(".wdr_table_discounted_price").text().trim().replace(/[^\d.]/g, "")); // Parse numeric value
      return { range, discount };
    }).get();

    const matchedDiscount = discountArray.find(({ range }) => quantity >= range && quantity <= range);

    return matchedDiscount ? matchedDiscount.discount : 0;
  }

  const updateSummaryItem = (htmlItem, updatedText, isDiscount, isCount) => {
    if(isDiscount) {
      $(htmlItem).html(wc_price_discount(updatedText));
    } else if(isCount) {
      $(htmlItem).html(updatedText + ' st');
    } else {
      $(htmlItem).html(wc_price(updatedText));
    }
  }

  const calculateBulkDiscount = (oldSinglePrice, newSinglePrice) => {
    const newPrice = oldSinglePrice - newSinglePrice;
    return newPrice;
  }

  // const calculatePercentageSaved = (oldSinglePrice, newSinglePrice, quantity) => {
  //   const orgPrice = oldSinglePrice * quantity;
  //   const newPrice = oldSinglePrice - newSinglePrice;
  //   const percentageSavedPrice = newPrice / orgPrice * 100;

  //   return percentageSavedPrice;
  // }

  const wc_price = (price) => {
    return price + ' kr';
  }

  const wc_price_discount = (price) => {
    return Math.ceil(price) + '% prisavdrag';
  }
};


export default productSummary;
